export default "__VITE_ASSET__CqMxqumI__"